import React, { memo, useState } from 'react';
import { Stack, ToggleButtonGroup, ToggleButton } from 'investira.react.components';
import AtivoRentabilidadeSelectMenu from './AtivoRentabilidadeSelectMenu';
import { getAtivoRentabilidadeIndicadores } from './ativoRentabilidadeIndicadores';

/** Controles exclusivos da apresentação de rentabilidade. */
const AtivoRentabilidadeControls = memo(({ range = {}, indicador = {} }) => {
  const [rangeSelected, setRangeSelected] = useState(range.selected);
  const xIndicadores = getAtivoRentabilidadeIndicadores();

  return (
    <Stack
      marginTop={{ xs: 2, md: 0 }}
      spacing={2}
      direction={{ xs: 'column', md: 'row' }}
      alignItems={{ md: 'center' }}
      flexGrow={1}
      width="100%">
      <Stack
        spacing={2}
        direction="row"
        flexGrow={1}
        justifyContent={{ xs: 'space-between', md: 'flex-end' }}
        alignItems={{ xs: 'center' }}>
        <Stack spacing={2} direction="row" sx={{ maxWidth: '200px' }}>
          {indicador.onChange ? (
            <AtivoRentabilidadeSelectMenu
              value={indicador.value}
              renderValue={pValue => pValue}
              options={xIndicadores.map((xIndicador, xIndex) => ({
                value: xIndicador.indicador_id,
                label: `${xIndicador.indicador_id} - ${xIndicador.indicador}`,
                index: xIndex,
                disabled: false
              }))}
              onChange={indicador.onChange}
            />
          ) : null}
        </Stack>
      </Stack>
      <Stack spacing={2} direction="row">
        <ToggleButtonGroup value={rangeSelected} size="small" color="primary" fullWidth>
          {range.buttons.map((xOption, xIndex) => (
            <ToggleButton
              key={xOption.text}
              onClick={() => {
                range.setRange(xOption.type, xOption.count, xIndex);
                setRangeSelected(xIndex);
              }}
              value={xIndex}>
              {xOption.text}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Stack>
    </Stack>
  );
});

export default AtivoRentabilidadeControls;
